import BankIDVerification from "./BankIDVerification";

export default BankIDVerification;
